var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9603 51.4409L77.9663 51.4436C78.1284 51.5166 78.25 51.6927 78.25 51.9033V64.0722C78.25 64.2473 78.186 64.3714 78.1072 64.4512C78.028 64.5314 77.9185 64.5833 77.78 64.5833H8.54889C8.25843 64.5833 8.03582 64.4806 7.90473 64.3655C7.78077 64.2567 7.75 64.1549 7.75 64.0722V51.9033C7.75 51.8453 7.80142 51.6173 8.15882 51.4775L8.16786 51.4739C12.3476 49.8115 15.2733 46.0249 15.2733 41.6667C15.2733 37.3084 12.3476 33.5218 8.16786 31.8595L8.16787 31.8594L8.15881 31.8559C7.80143 31.716 7.75 31.4881 7.75 31.43V19.2611C7.75 19.1784 7.78077 19.0766 7.90473 18.9678C8.03582 18.8528 8.25842 18.75 8.54889 18.75H77.78C77.9185 18.75 78.028 18.8019 78.1072 18.8822C78.186 18.9619 78.25 19.086 78.25 19.2611V31.43C78.25 31.6406 78.1284 31.8167 77.9663 31.8897L77.9603 31.8924C74.1612 33.6193 71.7133 37.4546 71.7133 41.6667C71.7133 45.8788 74.1612 49.7141 77.9603 51.4409Z",
    stroke: "#FB5381",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.4004,
    y: 29.3433,
    width: 5.92,
    height: 5.92,
    fill: "#FB5381"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4004,
    y: 39.2003,
    width: 5.92,
    height: 5.92,
    fill: "#FB5381"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4004,
    y: 49.0862,
    width: 5.92,
    height: 5.92,
    fill: "#FB5381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManagement);
export default __webpack_public_path__ + "static/media/task_management.a2a895d2abb6ecd1335ad2fb2fe7d3c1.svg";
export { ForwardRef as ReactComponent };